import { ProductsScreen } from "@/screens/loans/ProductsScreen"

export default ProductsScreen
